import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import PlatformLayout from './components/PlatformLayout';
import LoginPage from './pages/LoginPage';
import OverviewPage from './pages/OverviewPage';
import TenantsPage from './pages/TenantsPage';
import PlansPage from './pages/PlansPage';
import BackupsPage from './pages/BackupsPage';

function App() {
  return (
    <AuthProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          <Route path="/login" element={<LoginPage />} />

          <Route
            element={
              <ProtectedRoute>
                <PlatformLayout />
              </ProtectedRoute>
            }
          >
            <Route path="/overview" element={<OverviewPage />} />
            <Route path="/tenants" element={<TenantsPage />} />
            <Route path="/plans" element={<PlansPage />} />
            <Route path="/backups" element={<BackupsPage />} />
          </Route>

          <Route path="/" element={<Navigate to="/overview" replace />} />
          <Route path="*" element={<Navigate to="/overview" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
